<app-header sectionName="Suppliers"></app-header>

<div class="page">
  <div class="list-toolbar">
    <mat-form-field appearance="outline" class="filter" subscriptSizing="dynamic">
      <mat-label>Search</mat-label>
      <input matInput [(ngModel)]="search" (keyup.enter)="onSearch()" placeholder="Name, username or phone">
      <mat-icon matPrefix>search</mat-icon>
    </mat-form-field>
    <button mat-flat-button color="primary" (click)="onSearch()">Search</button>
  </div>

  <div class="table-card">
  @if (loading) {
  <div class="table-state"><mat-spinner diameter="32"></mat-spinner></div>
  } @else if (error) {
  <div class="table-state error">
    <p>{{ error }}</p>
    <button mat-stroked-button (click)="load()">Retry</button>
  </div>
  } @else if (suppliers.length === 0) {
  <div class="table-state">No suppliers found.</div>
  } @else {
  <div class="table-scroll">
    <table mat-table [dataSource]="suppliers">
      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef>Name</th>
        <td mat-cell *matCellDef="let s" class="cell-title">
          <span class="title">{{ s.name }}</span>
          @if (s.auto_provisioned) {
          <div class="sub warn"
            matTooltip="Created by the migration for a legacy supplier name that matched no user. It cannot log in until an admin attaches real credentials.">
            needs reconciliation
          </div>
          }
        </td>
      </ng-container>

      <ng-container matColumnDef="username">
        <th mat-header-cell *matHeaderCellDef>Username</th>
        <td mat-cell *matCellDef="let s" data-label="Username">
          <span class="mono">{{ s.username }}</span>
          @if (!s.active) { <div class="sub warn">inactive user</div> }
        </td>
      </ng-container>

      <ng-container matColumnDef="phone">
        <th mat-header-cell *matHeaderCellDef>Phone</th>
        <td mat-cell *matCellDef="let s" data-label="Phone"><span class="mono">{{ s.phone }}</span></td>
      </ng-container>

      <ng-container matColumnDef="priority">
        <th mat-header-cell *matHeaderCellDef>Priority</th>
        <td mat-cell *matCellDef="let s" data-label="Priority">
          <input class="num-input" type="number" min="0" [(ngModel)]="draft(s.user_id).priority">
        </td>
      </ng-container>

      <ng-container matColumnDef="allowance">
        <th mat-header-cell *matHeaderCellDef
          matTooltip="How many Active manual contracts this supplier may hold at once. Lowering it stops them opening more; it does not cancel work already running.">
          Manual contracts
        </th>
        <td mat-cell *matCellDef="let s" data-label="Manual contracts">
          <input class="num-input" type="number" min="0" [(ngModel)]="draft(s.user_id).allowance">
          <span class="sub">in use: {{ s.active_manual_contracts }}</span>
        </td>
      </ng-container>

      <ng-container matColumnDef="enabled">
        <th mat-header-cell *matHeaderCellDef>Enabled</th>
        <td mat-cell *matCellDef="let s" data-label="Enabled">
          <mat-slide-toggle [checked]="s.enabled" [disabled]="!canEdit" (change)="toggleEnabled(s, $event.checked)"></mat-slide-toggle>
        </td>
      </ng-container>

      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let s" class="cell-actions">
          @if (canEdit) {
          <button mat-flat-button color="primary" [disabled]="!dirty(s)" (click)="save(s)">Save</button>
          }
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="cols"></tr>
      <tr mat-row *matRowDef="let row; columns: cols;"></tr>
    </table>
  </div>
  }

  <mat-paginator
    [length]="total"
    [pageIndex]="pageIndex"
    [pageSize]="pageSize"
    [pageSizeOptions]="pageSizeOptions"
    (page)="onPage($event)">
  </mat-paginator>
  </div>
</div>